import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { MainList } from './MainList';
import { SecondaryList } from './SecondaryList';

import styles from './HorizontalNavigation.css';

const HorizontalNavigation = ({ browserBarOpen }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className={cx(styles.container, {
        [styles.containerHidden]: browserBarOpen,
        [styles.onFront]: show,
      })}
    >
      <nav className={styles.horizontalNavigation} key="main">
        <MainList toggleMenu={() => setShow(!show)} />
      </nav>
      <SecondaryList show={show} onOutsideClick={() => setShow(false)} />
    </div>
  );
};

HorizontalNavigation.defaultProps = {
  browserBarOpen: false,
};

HorizontalNavigation.propTypes = {
  browserBarOpen: PropTypes.bool,
};

export { HorizontalNavigation };
